import React, {Component, Fragment} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import SignatureCanvas from "react-signature-canvas";
import {FormattedMessage, injectIntl} from "react-intl";

import {showContractSigning, showSignaturePad} from "../../../actions/actionFunctions";
import {renderErrorPopup} from "../../../api/api-popups";
import Analytics from "../../../analytics";
import {postContractSign} from "../../../api/contract-api";

class ContractSignPopup extends Component {

  constructor(props) {
    super(props);

    this.state = {
      firstName: props.firstName,
      lastName: props.lastName,
      custom: ''
    }
  }

  componentDidMount() {
    if (this.props.step !== 3 && this.sigCanvas && this.props.signaturePadTag && this.props.pagesCustomFieldsValue) {
      const {pageIndex, fieldIndex} = this.props.signaturePadTag;
      if (this.props.pagesCustomFieldsValue[pageIndex]
        && this.props.pagesCustomFieldsValue[pageIndex][fieldIndex]
        && this.props.pagesCustomFieldsValue[pageIndex][fieldIndex].value) {
        this.setSignatureImage(this.props.pagesCustomFieldsValue[pageIndex][fieldIndex].value);
      }
    }
  }

  setSignatureImage = (base64Image) => {
    // here we are not using native .fromDataURL() method, because it is resizing the image, if we want to use fromDataURL
    // then we need instead of .getTrimmedCanvas().toDataURL('image/png') use .toDataURL(), but it enlarges the image
    this.sigCanvas._sigPad._reset();
    const copy = document.createElement('canvas');
    copy.width = this.sigCanvas._canvas.width
    copy.height = this.sigCanvas._canvas.height;
    const image = new Image();
    image.src = base64Image;
    image.onload = () => {
      copy.getContext('2d').drawImage(image,
        copy.width / 2 - image.width / 2,
        copy.height / 2 - image.height / 2
      );
      this.sigCanvas.fromDataURL(copy.toDataURL('image/png'));
      this.sigCanvas._sigPad._isEmpty = false;
    };
  }

  setProp = (name, value) => {
    this.setState({[name]: value});
  }

  isInformationFilled = () => {
    // return !_.isEmpty(this.state.firstName.trim()) &&
    //   !_.isEmpty(this.state.lastName.trim()) &&
    return this.sigCanvas &&
      !this.sigCanvas.isEmpty();
  }

  postContractSignature = () => {
    if (!this.isInformationFilled()) {
      const {intl} = this.props;
      if (!this.props.isClientSideOnly) {
        renderErrorPopup(intl.formatMessage({id: "contractSign.errorSignedPopupMessage"}), "", this.postContractSignature.bind(this));
      } else {
        renderErrorPopup(intl.formatMessage({id: "contractSign.errorSignaturePopupMessage"}), "", this.postContractSignature.bind(this));
      }

      return;
    }

    if (this.props.isClientSideOnly) {
      this.props.clientSideCallback(this.sigCanvas.getTrimmedCanvas().toDataURL('image/png'));
      return;
    }

    const data = {
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      custom: this.state.custom,
      signaturePngBase64: this.sigCanvas.getTrimmedCanvas().toDataURL('image/png'),
      offlineRetryCallback: this.postContractSignature.bind(this),
    }

    postContractSign(data);
  }

  closeContractSigning = step => {
    if (step === 3) {
      Analytics.sendClickEvent("contract-signed-ok");
      this.props.showContractSigning(false);
      this.props.contractSigningCallback();
    } else {
      this.props.showSignaturePad(false);
    }
  }

  render() {
    const {step, customerEmail} = this.props;
    const isFinished = step === 3;

    return (
      <div className="overlay overlay--contract-popup">
        <div className="contract-popup">
          {isFinished ? (
            <Fragment>
              <div className="contract-popup__success">
                <div className="contract-success">
                  <p className="contract-success__text"><FormattedMessage id="contractSign.contractSuccessText"/></p>
                  <p className="contract-success__email">{customerEmail}</p>
                </div>
              </div>
              <div className="contract-popup__footer">
                <button className="ui-button2 ui-button2--green ui-button3--wide" onClick={() => this.closeContractSigning(step)}>
                  <FormattedMessage id="contractSign.footerCloseButton"/>
                </button>
              </div>
            </Fragment>
          ) : (
            <Fragment>
              <div className="contract-popup__header">
                <div className="secondary"><span className="red">*</span> <FormattedMessage id="contractSign.requiredFieldsNotice"/></div>
                <div className="contract-popup__header-title"><FormattedMessage id="contractSign.requiredFieldsNoticeText"/></div>
              </div>
              <div className="contract-popup__body">
                {/*<div className="contract-popup__body-inputs">*/}
                {/*  <div className="contract-input">*/}
                {/*    <label htmlFor="firstName" className="secondary">First Name <span className="red">*</span></label>*/}
                {/*    <input type="text" id="firstName" className={"ui-input"} value={this.state.firstName}*/}
                {/*           onChange={e => this.setProp('firstName', e.target.value)}/>*/}
                {/*  </div>*/}
                {/*  <div className="contract-input">*/}
                {/*    <label htmlFor="lastName" className="secondary">Last Name <span className="red">*</span></label>*/}
                {/*    <input type="text" id="lastName" className={"ui-input"} value={this.state.lastName}*/}
                {/*           onChange={e => this.setProp('lastName', e.target.value)}/>*/}
                {/*  </div>*/}
                {/*</div>*/}
                {/*<div className="contract-popup__body-inputs contract-popup__body-inputs--full">*/}
                {/*  <label htmlFor="custom" className="secondary">Address <span className="red">*</span></label>*/}
                {/*  <input type="text" id="custom" className={"ui-input"} value={this.state.custom}*/}
                {/*         onChange={e => this.setProp('custom', e.target.value)}/>*/}
                {/*</div>*/}
                <div className="contract-popup__body-sign">
                  <SignatureCanvas canvasProps={{className: 'contract-popup__body-sign-canvas'}}
                                   ref={ref => this.sigCanvas = ref}>
                  </SignatureCanvas>
                </div>
              </div>
              <div className="contract-popup__footer">
                <button className="ui-button2 ui-button2--blue ui-button3--wide" onClick={() => this.sigCanvas.clear()}>
                  <FormattedMessage id="contractSign.footerClearButton"/>
                </button>
                <button className="ui-button2 ui-button2--green ui-button3--wide"
                        onClick={this.postContractSignature}>
                  <FormattedMessage id={
                    this.props.isClientSideOnly ? "contractSign.footerSignButton" : "contractSign.footerFinishButton"
                  }/>
                </button>
              </div>
            </Fragment>
          )}
          <button className="ui-close contract-popup__close" onClick={() => this.closeContractSigning(-1)}/>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  const {userState, contractSigningState} = state;
  const [firstName, lastName] = userState.userInfo.firstName.split(' ');
  return {
    firstName,
    lastName,
    customerEmail: userState.userInfo.email,
    step: contractSigningState.step,
    contractSigningCallback: contractSigningState.callback,
    signaturePadTag: contractSigningState.signaturePadTag,
    pagesCustomFieldsValue: contractSigningState.pagesCustomFieldsValue,
  }
};

const mapDispatchToProps = {
  showContractSigning,
  showSignaturePad
};

ContractSignPopup.propTypes = {
  step: PropTypes.number.isRequired,
  isSignaturePadVisible: PropTypes.bool,
  firstName: PropTypes.string.isRequired,
  lastName: PropTypes.string,
  customerEmail: PropTypes.string,
  contractSigningCallback: PropTypes.func,
  showContractSigning: PropTypes.func,
  showSignaturePad: PropTypes.func,
  isClientSideOnly: PropTypes.bool,
  clientSideCallback: PropTypes.func
}

ContractSignPopup.defaultValues = {
  isClientSideOnly: false
}

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ContractSignPopup)
)
